import { cacheDecorator } from '@ds/swymkit/tools'

import { swymFetch } from '~/services/fetch-swym'

import { mediaParser } from '~/entities/content/media/api/parser-media'
import type { IMediaResponseV2 } from '~/entities/content/media/interfaces/media'

import type { IUpdateParams } from '~/features-shared/content/api/interfaces/params'
import type { IContent } from '~/features-shared/content/interfaces/content'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'

import type { ICRUDService, ICRUDServiceParams } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

interface ICreationMediaParams extends Omit<ICRUDServiceParams, 'subject_uri'> {}

type IReadMediaParams = ICRUDServiceParams

type IUpdateMediaParams = ICRUDServiceParams & Omit<ICreationMediaParams, 'published'> & IUpdateParams

type IDeleteMediaParams = ICRUDServiceParams

const isV2 = true

export const MEDIA_CRUD_API: ICRUDService<
  IContent,
  ICreationMediaParams,
  IReadMediaParams,
  IUpdateMediaParams,
  IDeleteMediaParams
> = {

  read(params, tracker) {
    const mediaId = params.subject_uri.split(':')
      .pop()

    return cacheDecorator(
      `media-${params.subject_uri}`,
      () => swymFetch
        .get(`/api/v2/media/${mediaId}`, { tracker })
        .json<SwymResponse<IMediaResponseV2>>()
        .then(async (response) => {
          const mediaParsed = await mediaParser(response, isV2)
          mediaParsed.result.model = IContentModel.Media
          return mediaParsed
        }),
      2000,
    )
  },

  // Coming
  create() { return null as any },
  update() { return null as any },
  delete() { return null as any },
}
